module.exports = __webpack_public_path__ + "static/media/HEART-13-KING.f031b4b1.svg";